import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import back_n from "../Tutorials/Image/back_n.gif";
import back_o from "../Tutorials/Image/back_o.gif";
import back_d from "../Tutorials/Image/back_d.gif";
import principle_n from "../Tutorials/Image/principle_n.gif";
import tutorials_n from "../Tutorials/Image/tutorials_n.gif";
import clue_n from "../Tutorials/Image/clue_n.gif";
import solution_n from "../Tutorials/Image/solution_n.gif";
import solution_o from "../Tutorials/Image/solution_o.gif";
import solution_d from "../Tutorials/Image/solution_d.gif";
import next_n from "../Tutorials/Image/next_n.gif";
import next_o from "../Tutorials/Image/next_o.gif";
import next_d from "../Tutorials/Image/next_d.gif";
import ok_n from "../Tutorials/Image/ok_n.gif";
import ok_o from "../Tutorials/Image/ok_o.gif";
import ok_d from "../Tutorials/Image/ok_d.gif";
import done_o from "../Tutorials/Image/done_o.gif";
import done_n from "../Tutorials/Image/done_n.gif";
import x_close_btn_n from "../Tutorials/Image/x_close_btn_n.png";
import x_close_btn_o from "../Tutorials/Image/x_close_btn_o.png";
import next_step_btn_n from "../Tutorials/Image/next_step_btn_n.png";
import next_step_btn_o from "../Tutorials/Image/next_step_btn_o.png";
import got_it_btn_n from "../Tutorials/Image/got_it_btn_n.png";
import got_it_btn_o from "../Tutorials/Image/got_it_btn_o.png";
import './Style/Question.css';
import Loading from "../../Common/Loading";
import { buildNextQuestionData, buildOptionOrder ,buildShuffledQuestionsOrder, saveQuestionPerformance, QuestionPerformancePayload } from '../../services/questionApi';
import ReactDOM from 'react-dom';
import { useViewLessonPreview } from './hooks/useViewLessonPreview';

export interface AnswerRef {
  getAnswer: () => {
    marks: number;
    noOfOptions: number;
    enteredCorrectAnswer: string;
    enteredWrongAnswer: string;
    enteredBlankAnswer: string;
    optOrder?: string;
    scoringMethod?: number | null;
  } | null;
  getSkipMetadata?: () => { noOfOptions: number; optOrder: string } | null;
}

interface RadioQnsProps {
  lessonMeta?: any;
  questionHtml: string;
  currentPage: number;
  totalPages: number;
  goToNextPage?: (e: React.MouseEvent) => void;
  showAlert: (message: string) => void;
  correctAudio: string[];
  incorrectAudio: string[];
  assetsBaseUrl?: string;
  sessionId: number | null;
  isCompleting?: boolean;
  updateSessionPoints?: (pointsEarned: number) => void;
  hwid?: number | null;
  subject?: string;
  previewMode?: string | null;
}

const injectRadioBridge = (html: string): string => {
  let cleaned = html
    .replace(/onmousemove="[^"]*"/gi, "")
    .replace(/<script[\s\S]*?<\/script>/gi, "");

  const bridge = `
    <style>
      body { font-family: Arial, sans-serif; }
      #el-options-container table, #el-options-container tr, #el-options-container td {
        border: none !important; border-collapse: collapse !important; padding: 0 !important; margin: 0;
      }
      #el-options-container { width: 100%; max-width: 800px; }
      #el-options-container table { width: 97.8vw; border-spacing: 0 10px; }
      
      .option-row {
        cursor: pointer; border-radius: 12px;
        transition: background-color 0.2s ease-in-out; overflow: hidden;
      }
      .option-row:nth-child(odd) { background-color: #F8F8F8; }
      .option-row:nth-child(even) { background-color: #fdf5ec; }
      .option-row.selected { background-color: #7A96DF !important; }
      
      .content-column { 
        display: table-cell !important;
      } 
    </style>
    <script>
      (function() {
        function bridgeLogic() {
          try {
            const optionsTable = document.querySelector('table[id^="KSD_TABLE"]');
            if (!optionsTable) { 
              setTimeout(bridgeLogic, 50);
              return; 
            }

            const container = optionsTable.parentElement;
            if (container) container.id = 'el-options-container';
            
            const allRows = optionsTable.querySelectorAll('tr[id^="KSD_TR_"]'); 
            
            allRows.forEach(row => {
              const radio = row.querySelector('input[type="radio"]');
              const directCells = Array.from(row.children).filter(child => child.tagName === 'TD');
              
              if (!radio || directCells.length === 0) {
                console.warn("Radio Bridge: Skipping row, no radio or cells.", row);
                return;
              }

              const labelCell = row.querySelector('td[id="KSD_TD1"]');
              const labelFont = labelCell ? labelCell.querySelector('font[id^="Index"]') : null;
              if (!labelFont) {
                console.warn("Radio Bridge: Skipping row, no label font.", row);
                return;
              }

              const optionLetter = labelFont.textContent.trim().replace('.', '');
              radio.value = optionLetter;
              
              row.removeAttribute('style');
              row.classList.add('option-row');
              
              directCells.forEach(cell => {
                const id = cell.id || '';
                
                if (id === 'KSD_TD2') {
                  cell.style.display = ''; 
                  cell.classList.add('content-column');

                  const innerImageCell = cell.querySelector('table tr td');
                  if (innerImageCell) {
                    innerImageCell.style.setProperty('padding-left', '50px', 'important');
                  }

                } else {
                  cell.style.display = 'none'; 
                }
              });

              row.addEventListener('click', function() {
                allRows.forEach(r => { 
                  if(r.querySelector('input[type="radio"]')) r.classList.remove('selected'); 
                });
                this.classList.add('selected');
                radio.checked = true;
                parent.postMessage({ type: 'el-option-selected', option: radio.value }, '*');
              });
            });
          } catch(e) { console.error("Radio Bridge Error:", e); }
        }
        
        bridgeLogic();
      })();
    </script>
  `;
  return cleaned.includes("</body>") ? cleaned.replace("</body>", bridge + "</body>") : cleaned + bridge;
};

const RadioQns: React.ForwardRefRenderFunction<AnswerRef, RadioQnsProps> = (props, ref) => {
  const {
    lessonMeta, questionHtml, currentPage, totalPages, goToNextPage, showAlert,
    correctAudio, incorrectAudio, assetsBaseUrl, sessionId, isCompleting, updateSessionPoints,
    hwid, subject, previewMode
  } = props;

  const navigate = useNavigate();
  const [backSrc, setBackSrc] = useState(back_n);
  const [nextSrc, setNextSrc] = useState(next_n);
  const [okSrc, setOkSrc] = useState(ok_n);
  const [doneSrc, setDoneSrc] = useState(done_n);
  const [solutionSrc, setSolutionSrc] = useState(solution_n);
  const [CloseBtnSrc, setCloseBtnSrc] = useState(x_close_btn_n);
  const [NextStepBtnSrc, setNextStepBtnSrc] = useState(next_step_btn_n);
  const [GotItBtnSrc, setGotItBtnSrc] = useState(got_it_btn_n);

  const [okClicked, setOkClicked] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const solnIframeRef = useRef<HTMLIFrameElement>(null);
  const clueIframeRef = useRef<HTMLIFrameElement>(null);
  const prcIframeRef = useRef<HTMLIFrameElement>(null);

  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [currentQnMeta, setCurrentQnMeta] = useState<any | null>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [startTime, setStartTime] = useState<Date | null>(null);

  const [showClueModal, setShowClueModal] = useState(false);
  const [clueContent, setClueContent] = useState('');
  const [isClueLoading, setIsClueLoading] = useState(false);
  const [noOfClues, setNoOfClues] = useState(0);
  const [currentClueNo, setCurrentClueNo] = useState(0);
  const [clueSeen, setClueSeen] = useState(false);

  const [showPrcModal, setShowPrcModal] = useState(false);
  const [prcContent, setPrcContent] = useState("");
  const [isPrcLoading, setIsPrcLoading] = useState(false);
  const [prcSeen, setPrcSeen] = useState(false);
  const [principleList, setPrincipleList] = useState<string[]>([]);
  const [currentPrcIndex, setCurrentPrcIndex] = useState(0);

  const [showSolnModal, setShowSolnModal] = useState(false);
  const [isSolnLoading, setIsSolnLoading] = useState(false);
  const [solnContent, setSolnContent] = useState("");
  const [solutionSeen, setSolutionSeen] = useState<string | number>('N');
  const [currentSolnNo, setCurrentSolnNo] = useState(0);
  const [revealedSolnSteps, setRevealedSolnSteps] = useState<number[]>([]);
  useEffect(() => {
    setCurrentSolnNo(0);
    setRevealedSolnSteps([]);
  }, [currentQnMeta?.QnNo]);
  const [noOfSteps, setNoOfSteps] = useState(0);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const folderParam = params.get('folder') || 'GRPONE_E';
  const lessonName = params.get('name') || 'Group of one';
  const diccode = params.get('diccode');
  const calledFrom = params.get('calledFrom');
  const isInAssessment = window.location.href.includes('Assessment');

  const handleBackMouseOver = () => setBackSrc(back_o);
  const handleBackMouseOut = () => setBackSrc(back_n);
  const handleBackMouseDown = () => setBackSrc(back_d);
  const handleBackMouseUp = () => setBackSrc(back_o);
  const handleNextMouseOver = () => setNextSrc(next_o);
  const handleNextMouseOut = () => setNextSrc(next_n);
  const handleNextMouseDown = () => setNextSrc(next_d);
  const handleNextMouseUp = () => setNextSrc(next_o);
  const handleOkMouseOver = () => setOkSrc(ok_o);
  const handleOkMouseOut = () => setOkSrc(ok_n);
  const handleOkMouseDown = () => setOkSrc(ok_d);
  const handleOkMouseUp = () => setOkSrc(ok_o);
  const handleSolutionMouseOver = () => setSolutionSrc(solution_o);
  const handleSolutionMouseOut = () => setSolutionSrc(solution_n);
  const handleSolutionMouseDown = () => setSolutionSrc(solution_d);
  const handleCloseBtnMouseOver = () => setCloseBtnSrc(x_close_btn_o);
  const handleCloseBtnMouseOut = () => setCloseBtnSrc(x_close_btn_n);
  const handleNextStepBtnMouseOver = () => setNextStepBtnSrc(next_step_btn_o);
  const handleNextStepBtnMouseOut = () => setNextStepBtnSrc(next_step_btn_n);
  const handleGotItBtnMouseOver = () => setGotItBtnSrc(got_it_btn_o);
  const handleGotItBtnMouseOut = () => setGotItBtnSrc(got_it_btn_n);

  const { isViewLesson, isAnswerMode, isSolutionMode, isPreview, guardSave, handleDoneClick } = useViewLessonPreview(previewMode);

  useEffect(() => {
    setSelectedOption(null);
    setOkClicked(false);
    setStartTime(new Date());
    setClueSeen(false);
    setPrcSeen(false);
    setSolutionSeen('N');
    if (lessonMeta?.qns) setCurrentQnMeta(lessonMeta.qns[currentPage - 1]);
  }, [currentPage, lessonMeta]);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe && questionHtml) iframe.srcdoc = injectRadioBridge(questionHtml);
  }, [questionHtml]);

  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.data?.type === 'el-option-selected') setSelectedOption(String(e.data.option));
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  const getSkipMetadata = useCallback(() => {
    const iframeDoc = iframeRef.current?.contentDocument;
    if (!iframeDoc) return null;

    const noOfOptions = iframeDoc.querySelectorAll('tr.option-row, tr[id^="KSD_TR_"]').length;
    if (noOfOptions === 0) return null;

    return {
      noOfOptions,
      optOrder: buildOptionOrder(iframeRef.current, 'O'),
    };
  }, []);

  useImperativeHandle(ref, () => ({
    getAnswer: () => {
      if (selectedOption == null) {
        showAlert("Please select an answer.");
        return null;
      }

      const iframe = iframeRef.current;
      if (!iframe?.contentDocument) return null;
      const iframeDoc = iframe.contentDocument;

      const questionTextContent = iframeDoc.querySelector('td[height="30"]')?.textContent || "";
      const cleanedText = questionTextContent.replace(/\s+/g, ' ').toLowerCase();

      let correctAnswerLetter: string | null = null;
      const allRows = iframeDoc.querySelectorAll<HTMLElement>('tr.option-row');

      // This component now ONLY handles "group of"
      if (cleanedText.includes("group of")) {
        const match = cleanedText.match(/group of (\d+)/i);
        const targetCount = match ? parseInt(match[1], 10) : null;

        if (targetCount === null) {
          showAlert("Error: Could not parse 'group of' question.");
          return null;
        }

        allRows.forEach(row => {
          const contentCol = row.querySelector('.content-column');
          const imageCount = contentCol ? contentCol.querySelectorAll('img').length : 0;
          if (imageCount === targetCount) {
            const radio = row.querySelector('input[type="radio"]');
            if (radio) {
              correctAnswerLetter = (radio as HTMLInputElement).value;
            }
          }
        });
      } else {
        showAlert("Error: This component only handles 'group of' questions.");
        return null;
      }

      if (correctAnswerLetter === null) {
        showAlert("Error: Could not determine the correct answer.");
        return null;
      }

      const isCorrect = selectedOption === correctAnswerLetter;
      const marks = isCorrect ? 1 : 0;

      return {
        marks,
        noOfOptions: allRows.length,
        enteredCorrectAnswer: isCorrect ? selectedOption : "",
        enteredWrongAnswer: !isCorrect ? selectedOption : "",
        enteredBlankAnswer: "",
        optOrder: buildOptionOrder(iframeRef.current, 'O'),
        scoringMethod: null
      };
    },
    getSkipMetadata,
  }), [selectedOption, showAlert, getSkipMetadata]);

  const handleClueClick = useCallback(async () => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowClueModal(true);
    setIsClueLoading(true);
    setClueContent("");
    setCurrentClueNo(0);
    setNoOfClues(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';
    const varValuesParam = currentQnMeta?.VarValues || "";

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsClueLoading(false);
      setShowClueModal(false);
      return;
    }

    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      console.warn("Access token not found in localStorage.");
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

    try {
      const response = await fetch(`${apiUrl}clue/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          varValues: varValuesParam,
        }),
      });

      if (!response.ok) {
        if (response.status === 404) {
          setClueContent("");
        } else {
          if (response.status === 401 || response.status === 403) {
            showAlert("Authentication failed. Please log in again.");
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } else {
        const data = await response.json();
        setClueContent(data.clueHtml || "");
        setClueSeen(true);
      }

    } catch (error) {
      console.error("Error fetching clue:", error);
      if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403") || error.message.includes("status: 404")))) {
        showAlert("Failed to load the clue. Please try again.");
      }
      setClueContent("");
    } finally {
      setIsClueLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]);

  const fetchPrincipleContent = async (principleId: string, folderParam: string, countryParam: string) => {
    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

    const response = await fetch(`${apiUrl}principle/`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        folder: folderParam,
        questionNo: principleId,
        country: countryParam,
      }),
    });

    if (!response.ok) throw new Error("Failed");
    return await response.json();
  };

  const handlePrcClick = useCallback(async () => {
    if (!currentQnMeta || !lessonMeta) return;

    const prcString = currentQnMeta.PrincipleNos || "";
    const prcIds = prcString.replace(/"/g, "").split(',').filter((s: string) => s.trim() !== "");

    if (prcIds.length === 0) {
      if ((currentQnMeta.NoOfPrc || 0) > 0) {
        prcIds.push("1");
      } else {
        showAlert("No principles found for this question.");
        return;
      }
    }

    setShowPrcModal(true);
    setIsPrcLoading(true);
    setPrcContent("");
    setPrincipleList(prcIds);
    setCurrentPrcIndex(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsPrcLoading(false);
      setShowPrcModal(false);
      return;
    }

    try {
      const data = await fetchPrincipleContent(prcIds[0], folderParam, countryParam);
      setPrcContent(data.principleHtml || "");
      setPrcSeen(true);
    } catch (error) {
      console.error("Error fetching principle:", error);
      setPrcContent("");
    } finally {
      setIsPrcLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]);

  const handleSolnClick = useCallback(async (autoExpand = false) => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowSolnModal(true);
    setIsSolnLoading(true);
    setSolnContent("");
    setNoOfSteps(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsSolnLoading(false);
      setShowSolnModal(false);
      return;
    }

    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      console.warn("Access token not found in localStorage.");
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

    try {
      const response = await fetch(`${apiUrl}solution/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          autoExpand: autoExpand,
        }),
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          showAlert("Authentication failed. Please log in again.");
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setSolnContent(data.solutionHtml || "");
      if (solutionSeen === 'N') {
        setSolutionSeen(1);
      }

    } catch (error) {
      console.error("Error fetching solution:", error);
      if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403")))) {
        showAlert("Failed to load the solution. Please try again.");
      }
      setShowSolnModal(false);
    } finally {
      setIsSolnLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, solutionSeen]);

  const playRandomSound = useCallback(async (soundFiles: string[], folder: 'Correct' | 'Incorrect') => {
    const baseUrl = assetsBaseUrl || "https://www.elearnoncloud.com/Storage/assets/";
    if (!soundFiles || soundFiles.length === 0) return;

    const fileName = soundFiles[Math.floor(Math.random() * soundFiles.length)];
    const audioUrl = `${baseUrl}Audio/Question/${folder}/${fileName}`;

    const audio = new Audio(audioUrl);
    try {
      await audio.play();
    } catch (error) {
      console.error(`Error playing audio from ${audioUrl}:`, error);
    }
  }, [assetsBaseUrl]);

  const handleDbUpdate = useCallback(guardSave((payload: QuestionPerformancePayload) => {
    return saveQuestionPerformance(payload)
      .then((data) => { if (isCompleting && updateSessionPoints) updateSessionPoints(data.pointsEarned || 0); return data; })
      .catch((error) => { console.error("Save Performance Error:", error); throw error; });
  }), [isCompleting, updateSessionPoints, guardSave]);

  const handleOkClick = async (e: React.MouseEvent<any>) => {
    e.preventDefault();
    if (okClicked || isSubmitting) return;
    if (selectedOption == null) {
      showAlert("Please select an answer.");
      return;
    }

    const iframe = iframeRef.current;
    if (!iframe?.contentDocument) return;
    const iframeDoc = iframe.contentDocument;

    // Logic to determine if this is the final submit
    const isLastQuestion = currentPage === totalPages;

    const questionTextContent = iframeDoc.querySelector('td[height="30"]')?.textContent || "";
    const cleanedText = questionTextContent.replace(/\s+/g, ' ').toLowerCase();

    let correctAnswerLetter: string | null = null;
    const allRows = iframeDoc.querySelectorAll<HTMLElement>('tr.option-row');

    if (cleanedText.includes("group of")) {
      const match = cleanedText.match(/group of (\d+)/i);
      const targetCount = match ? parseInt(match[1], 10) : null;
      if (targetCount === null) {
        showAlert("Error: Could not parse 'group of' question.");
        return;
      }
      allRows.forEach(row => {
        const contentCol = row.querySelector('.content-column');
        const imageCount = contentCol ? contentCol.querySelectorAll('img').length : 0;
        if (imageCount === targetCount) {
          const radio = row.querySelector('input[type="radio"]');
          if (radio) {
            correctAnswerLetter = (radio as HTMLInputElement).value;
          }
        }
      });
    } else {
      showAlert("Error: This component only handles 'group of' questions.");
      return;
    }

    if (correctAnswerLetter === null) {
      showAlert("Error: Could not determine the correct answer.");
      return;
    }

    const isCorrect = selectedOption === correctAnswerLetter;
    const marks = isCorrect ? 1 : 0;

    const questionAnswerTime = startTime ? Math.floor((new Date().getTime() - startTime.getTime()) / 1000) : 0;
    const schoolCode = sessionStorage.getItem('SchoolCode') || '';
    const familyCode = sessionStorage.getItem('FamilyCode') || '';
    const login = sessionStorage.getItem('Login') || '';
    const chapterCode = sessionStorage.getItem('ChapterCode') || '';
    const unitCode = sessionStorage.getItem('UnitCode') || '';

    const payload: QuestionPerformancePayload = {
      schoolCode, familyCode, login,
      dicCode: sessionStorage.getItem('SelectedDICFile') || '',
      lsnTestCode: sessionStorage.getItem('LsnTestCode') || '',
      sessionId: sessionId || 1,
      qnNo: currentQnMeta?.QnNo,
      subNo: 0,
      qnType: currentQnMeta?.QnType,
      marks: marks,
      noOfOptions: allRows.length,
      enteredCorrectAnswer: isCorrect ? selectedOption : "",
      enteredWrongAnswer: !isCorrect ? selectedOption : "",
      enteredBlankAnswer: "",
      solutionSeen: (typeof solutionSeen === 'number' && solutionSeen > 0) || solutionSeen === 'Y' ? 'Y' : 'N',
      clueSeen: clueSeen,
      principleSeen: prcSeen,
      questionLoadTime: 0,
      questionAnswerTime: questionAnswerTime,
      lastQnInd: currentQnMeta?.LastQnInd || currentPage,
      nextQnData: buildNextQuestionData(lessonMeta?.qns, currentPage),
      dbgShuffledQnsOrder: buildShuffledQuestionsOrder(lessonMeta?.qns),
      allQuestionsCompleted: isCompleting ? 'True' : 'False',
      chapterCode: chapterCode,
      unitCode: unitCode,
      optOrder: buildOptionOrder(iframeRef.current, 'O'),
      // WLP activities are identified by HWID 0. Preserve it so that the
      // completion endpoint can update the matching weekly-plan row.
      hwid,
      subject
    };

    if (isLastQuestion) {
      setIsSubmitting(true);
      try {
        await handleDbUpdate(payload);
      } catch (e) {
        console.error("Final submit failed", e);
        showAlert("Error saving progress. Please try again.");
        setIsSubmitting(false);
        return;
      }
      setIsSubmitting(false);
    } else {
      handleDbUpdate(payload).catch(e => console.error("Background save failed", e));
    }

    const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";
    const WRONG_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsWrong.GIF";
    const AnsShouldbe_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsShouldbe.GIF";

    iframeDoc.querySelectorAll('img[data-mark="1"]').forEach(img => img.remove());
    allRows.forEach(row => { (row as HTMLElement).style.position = 'relative'; });

    const insertImage = (targetRow: HTMLElement | null, src: string, alt: string) => {
      if (!targetRow) return;
      const img = iframeDoc.createElement("img");
      img.setAttribute("data-mark", "1");
      img.src = src;
      img.alt = alt;
      img.style.position = 'absolute';
      img.style.left = '15px';
      img.style.top = '50%';
      img.style.transform = 'translateY(-50%)';
      img.style.width = '24px';
      img.style.height = '24px';
      targetRow.appendChild(img);
    };

    let selectedRow: HTMLElement | null = null;
    let correctRow: HTMLElement | null = null;
    allRows.forEach(row => {
      const radio = row.querySelector('input[type="radio"]');
      if (radio) {
        const letter = (radio as HTMLInputElement).value;
        if (letter === selectedOption) {
          selectedRow = row;
        }
        if (letter === correctAnswerLetter) {
          correctRow = row;
        }
      }
    });

    if (isCorrect) {
      insertImage(correctRow, CORRECT_URL, "Correct");
      playRandomSound(correctAudio, 'Correct');
    } else {
      insertImage(selectedRow, WRONG_URL, "Incorrect");
      insertImage(correctRow, AnsShouldbe_URL, "Correct Answer");
      playRandomSound(incorrectAudio, 'Incorrect');

      if (currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0) {
        handleSolnClick(true);
      }
    }

    iframeDoc.querySelectorAll('.option-row').forEach(row => {
      (row as HTMLElement).style.pointerEvents = 'none';
    });

    setOkClicked(true);
  };

  const handleBack = () => {
    const calledFrom = params.get("calledFrom");

    // console.log("calledFrom:", calledFrom);
    if (calledFrom) {
      const redirectPath = decodeURIComponent(calledFrom);
      window.location.href = redirectPath;
    }
    else if (window.history.length > 1) {
      window.history.back();
    }
  };

  return (
    <>
      {!isInAssessment && (
        <tr id="trQnButtons">
          <td className="QnPanelT">
            <table id="tabQnNav" className="QnPanel2T" style={{ height: "50px" }}>
              <tbody>
                <tr id="trQnOK" className="trQnOKT">
                  <td id="QnPanelIdT" className="QnPanel">&nbsp;</td>
                  <td id="QnPanelId2T" className="QnPanel">
                    <div
                      onClick={!okClicked ? handleBack : undefined}
                      style={{ display: okClicked ? 'none' : 'block', cursor: 'pointer' }}
                    >
                      <div id="imgbtnBack" className="imgbtnBackT">
                        <img
                          src={backSrc}
                          alt="Back"
                          onMouseOver={handleBackMouseOver}
                          onMouseOut={handleBackMouseOut}
                          onMouseDown={handleBackMouseDown}
                          onMouseUp={handleBackMouseUp}
                          className="imgbtnBack2T"
                        />
                      </div>
                    </div>
                  </td>
                  <td id="QnPanelId3T" className="QnPanel">
                    <input
                      type="image"
                      id="imgPrc"
                      src={principle_n}
                      className="imgPrcT"
                      alt="Principle"
                      style={{ display: !okClicked && currentQnMeta?.NoOfPrc && currentQnMeta.NoOfPrc > 0 ? 'inline-block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handlePrcClick(); }}
                    />
                  </td>
                  <td id="QnPanelId4T" className="QnPanel">
                    <input
                      type="image"
                      id="imgClue"
                      src={clue_n}
                      className="imgClueT"
                      alt="Clue"
                      style={{ display: !okClicked && Number(currentQnMeta?.NoOfClues || 0) > 0 ? 'inline-block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handleClueClick(); }}
                    />
                  </td>
                  <td id="QnPanelId5T" className="QnPanel">
                    <input
                      type="image" id="imgSoln" src={solutionSrc} className="imgSolnT" alt="Solution"
                      style={{ display: currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0 ? 'inline-block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handleSolnClick(false); }}
                      onMouseOver={handleSolutionMouseOver}
                      onMouseOut={handleSolutionMouseOut}
                      onMouseDown={handleSolutionMouseDown}
                    />
                  </td>
                  <td id="QnPanelId5T" className="QnPanel">
                    <a
                      href={`/STUDENT/Tutorials/Tutorial?id=${folderParam}&name=${encodeURIComponent(lessonName ?? '')}&folder=${encodeURIComponent(diccode ?? '')}&calledFrom=${encodeURIComponent(calledFrom ?? '')}&sessionId=${sessionId}&currentPage=${currentPage}`}
                      id="imgbtnTut"
                      className="imgbtnTutT"
                      style={{ display: okClicked ? 'none' : 'inline-block' }}
                    >
                      <img src={tutorials_n} alt="Tutorial" id="imgbtnTut2T" />
                    </a>
                  </td>
                  <td id="QnPanelId6T" className="QnPanel">
                    {isSubmitting ? (
                      <Loading />
                    ) : okClicked ? (
                      currentPage === totalPages ? (
                        <div
                          onClick={() => handleDoneClick(() => {
                            const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
                            const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
                            const calledFrom = params.get("calledFrom") || "";
                            navigate(`/STUDENT/Tutorials/Result?DicCode=${dicCode}&LsnTestCode=${lsnTestCode}&SessionID=${sessionId}&source=lesson&complete=1` + (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : ""));
                          })}
                          onMouseOver={() => setDoneSrc(done_o)}
                          onMouseOut={() => setDoneSrc(done_n)}
                          style={{ display: 'inline-block', cursor: 'pointer' }}
                        >
                          <img src={doneSrc} alt="Done" style={{ verticalAlign: 'middle' }} />
                        </div>
                      ) : (
                        <img
                          src={nextSrc}
                          alt="Next"
                          onClick={(e) => goToNextPage && goToNextPage(e)}
                          onMouseOver={handleNextMouseOver}
                          onMouseOut={handleNextMouseOut}
                          onMouseDown={handleNextMouseDown}
                          onMouseUp={handleNextMouseUp}
                          style={{ cursor: 'pointer', marginTop: '3px' }}
                        />
                      )
                    ) : (
                      <img
                        src={okSrc}
                        alt="OK"
                        onClick={handleOkClick}
                        onMouseOver={handleOkMouseOver}
                        onMouseOut={handleOkMouseOut}
                        onMouseDown={handleOkMouseDown}
                        onMouseUp={handleOkMouseUp}
                        style={{ cursor: 'pointer', marginTop: '3px' }}
                      />
                    )}
                  </td>
                  <td id="QnPanelId7" className="QnPanel">&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      )}
      <tr id="triFrame">
        <td id="tdFrameQnT" style={{ padding: 0, height: '100%' }}>
          <div id="divFrameQn" style={{ height: 'calc(95vh - 50px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
            {questionHtml ? (
              <iframe
                id="iFrameQn"
                ref={iframeRef}
                frameBorder={0}
                scrolling="yes"
                className="CssiFrm"
                style={{
                  flex: '1 1 0',
                  width: '100%',
                  height: '100%',
                  minHeight: 0,
                  border: 'none',
                  overflow: 'auto'
                }}
                title="Question Page"
                onLoad={() => {
                  if (!isPreview) return;

                  const iframeDoc = iframeRef.current?.contentDocument;
                  if (!iframeDoc) return;

                  try {
                    const questionTextContent = iframeDoc.querySelector('td[height="30"]')?.textContent || "";
                    const cleanedText = questionTextContent.replace(/\s+/g, ' ').toLowerCase();
                    const allRows = iframeDoc.querySelectorAll<HTMLElement>('tr.option-row');

                    if (!cleanedText.includes("group of")) return;
                    const match = cleanedText.match(/group of (\d+)/i);
                    const targetCount = match ? parseInt(match[1], 10) : null;
                    if (targetCount === null) return;

                    // NEW — admin preview only. Find the row whose image count matches
                    // the target, select its radio, mark the row visually correct, and
                    // lock all rows — mirrors what a real correct OK-click renders,
                    // without saving anything.
                    let correctLetter: string | null = null;
                    let correctRow: HTMLElement | null = null;

                    allRows.forEach(row => {
                      const contentCol = row.querySelector('.content-column');
                      const imageCount = contentCol ? contentCol.querySelectorAll('img').length : 0;
                      if (imageCount === targetCount) {
                        const radio = row.querySelector('input[type="radio"]');
                        if (radio) {
                          correctLetter = (radio as HTMLInputElement).value;
                          correctRow = row;
                        }
                      }
                    });

                    if (correctLetter && correctRow) {
                      (correctRow as HTMLElement).classList.add('selected');
                      const radio = (correctRow as HTMLElement).querySelector('input[type="radio"]') as HTMLInputElement | null;
                      if (radio) radio.checked = true;

                      const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";
                      const img = iframeDoc.createElement("img");
                      img.setAttribute("data-mark", "1");
                      img.src = CORRECT_URL;
                      img.alt = "Correct";
                      img.style.position = 'absolute';
                      img.style.left = '15px';
                      img.style.top = '50%';
                      img.style.transform = 'translateY(-50%)';
                      img.style.width = '24px';
                      img.style.height = '24px';
                      (correctRow as HTMLElement).style.position = 'relative';
                      (correctRow as HTMLElement).appendChild(img);

                      setSelectedOption(correctLetter);
                    }

                    iframeDoc.querySelectorAll('.option-row').forEach(row => {
                      (row as HTMLElement).style.pointerEvents = 'none';
                    });
                  } catch (e) {
                    console.error("Error revealing preview answer:", e);
                  }

                  setOkClicked(true);
                  if (isSolutionMode) {
                    handleSolnClick(true);
                  }
                }}
              />
            ) : <Loading />}
          </div>
        </td>
      </tr>

      {/* Modals */}
      {ReactDOM.createPortal(
        <>
          {showClueModal && (
            <>
              {!showSolnModal && <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowClueModal(false)}></div>}
              <div id="divClue" style={{ display: 'block' }}>
                <table id="tblTitleClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ height: "50px", fontSize: "15px" }}>
                  <tbody>
                    <tr>
                      <td id="tdClueTitle1" align="left">Clue</td>
                      <td id="tdClueClose" align="right" valign="top">
                        <img
                          id="imgClueClose"
                          src={CloseBtnSrc}
                          alt="Close"
                          onClick={() => setShowClueModal(false)}
                          onMouseOver={handleCloseBtnMouseOver}
                          onMouseOut={handleCloseBtnMouseOut}
                          style={{ cursor: 'pointer', padding: '5px' }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div id="divFrameClue">
                  {isClueLoading ? <Loading /> : (
                    <iframe
                      id="iFrameClue"
                      ref={clueIframeRef}
                      title="Clue"
                      srcDoc={clueContent}
                      style={{ width: '100%', border: 'none', minHeight: '80px' }}
                      onLoad={() => {
                        const iframe = clueIframeRef.current;
                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) { return; }
                        try {
                          const divShows = iframe.contentDocument.querySelectorAll("[id^='divShow']");
                          divShows.forEach(div => {
                            (div as HTMLElement).style.padding = "20px";
                          });
                          const cluesInput = iframe.contentDocument.getElementById('NoOfClues') as HTMLInputElement;
                          const totalClues = parseInt(cluesInput?.value || '0', 10);
                          setNoOfClues(totalClues);
                          const clueDivs = iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]');
                          clueDivs.forEach((div, index) => {
                            div.style.display = index === 0 ? 'block' : 'none';
                          });
                          const firstClueDiv = iframe.contentDocument.getElementById('divShow1');
                          if (firstClueDiv) {
                            const newHeight = firstClueDiv.scrollHeight;
                            iframe.style.height = `${Math.min(newHeight, 300)}px`;
                          } else if (totalClues === 0) {
                            iframe.style.height = '50px';
                          }
                        } catch (e) { console.error("Error inside clue iframe onLoad:", e); }
                      }}
                    />
                  )}
                </div>
                <table id="tblNavClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
                  <tbody>
                    <tr>
                      <td style={{ width: '33%' }}>&nbsp;</td>
                      <td style={{ width: '34%' }}>&nbsp;</td>
                      <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                        {!isClueLoading && noOfClues > 1 && currentClueNo < noOfClues - 1 && (
                          <img
                            id="btnClueNext"
                            src={NextStepBtnSrc}
                            alt="Next Clue"
                            onClick={() => {
                              const nextClue = currentClueNo + 1;
                              const iframe = clueIframeRef.current;
                              if (iframe?.contentDocument) {
                                iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]').forEach((div, index) => {
                                  div.style.display = index === nextClue ? 'block' : 'none';
                                });
                                setCurrentClueNo(nextClue);
                                const nextClueDiv = iframe.contentDocument.getElementById(`divShow${nextClue + 1}`);
                                if (nextClueDiv) {
                                  const newHeight = nextClueDiv.scrollHeight + 20;
                                  iframe.style.height = `${Math.min(newHeight, 300)}px`;
                                }
                              }
                            }}
                            onMouseOver={handleNextStepBtnMouseOver}
                            onMouseOut={handleNextStepBtnMouseOut}
                            style={{ cursor: 'pointer' }}
                          />
                        )}
                        {!isClueLoading && (noOfClues <= 1 || currentClueNo === noOfClues - 1) && (
                          <img
                            id="btnClueGotIt"
                            src={GotItBtnSrc}
                            alt="Got It"
                            onClick={() => setShowClueModal(false)}
                            onMouseOver={handleGotItBtnMouseOver}
                            onMouseOut={handleGotItBtnMouseOut}
                            style={{ cursor: 'pointer', display: isClueLoading ? 'none' : 'inline-block' }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}

          {showPrcModal && (
            <>
              <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowPrcModal(false)}></div>

              <div id="divPCS" style={{ display: 'block' }} className="principle">

                {/* Header */}
                <table id="tblTitlePCS" className="principle" cellSpacing="0" cellPadding="0" width="100%">
                  <tbody>
                    <tr>
                      <td id="tdPCSTitle1" style={{ paddingLeft: '15px', color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
                        Principle {principleList.length > 1 ? ` ${currentPrcIndex + 1} of ${principleList.length}` : ''}
                      </td>
                      <td id="tdPCSClose" align="right" valign="top">
                        <img
                          id="imgPCSClose"
                          src={CloseBtnSrc}
                          alt="Close"
                          onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                          onMouseOver={handleCloseBtnMouseOver}
                          onMouseOut={handleCloseBtnMouseOut}
                          style={{ cursor: 'pointer', padding: '5px', width: '40px', height: '40px', marginRight: '30px' }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Body */}
                <div id="divFramePCS">
                  {isPrcLoading ? <Loading /> : (
                    <iframe
                      id="iFramePrc"
                      ref={prcIframeRef}
                      title="Prc"
                      srcDoc={prcContent}
                      style={{ width: '100%', border: 'none', overflow: 'hidden', display: 'block' }} // 2. Set overflow hidden initially
                      onLoad={() => {
                        const iframe = prcIframeRef.current;
                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;

                        setTimeout(() => {
                          if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                          const contentHeight = iframe.contentDocument.body.scrollHeight + 20;

                          const divPCS = document.getElementById('divPCS') as HTMLElement;
                          const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                          const navTable = document.getElementById('tblNavPCS') as HTMLElement;
                          if (divPCS && titleTable && navTable) {
                            const maxModalHeight = window.innerHeight * 0.8;
                            const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;
                            if (contentHeight > maxIframeHeight) {

                              iframe.style.height = `${maxIframeHeight}px`;
                              iframe.style.overflowY = 'auto';
                            } else {

                              iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                              iframe.style.overflowY = 'hidden';
                            }
                          } else {
                            iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                          }
                        }, 50);
                      }}
                    />
                  )}
                </div>

                {/* Footer / Navigation */}
                <table id="tblNavPCS" className="principle" cellSpacing="0" cellPadding="0" width="100%" style={{ height: '50px' }}>
                  <tbody>
                    <tr style={{ backgroundColor: '#F2F2F2' }}>
                      {/* Previous Button */}
                      <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                        {currentPrcIndex > 0 && (
                          <input
                            type='button'
                            value='PREVIOUS'
                            onClick={() => {
                              const prevIndex = currentPrcIndex - 1;
                              setCurrentPrcIndex(prevIndex);
                              const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                              const countryParam = params.get('country') || 'Australia';
                              fetchPrincipleContent(principleList[prevIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                            }}
                            style={{
                              fontWeight: 'bold',
                              color: 'White',
                              fontSize: '12pt',
                              borderStyle: 'none',
                              backgroundColor: 'maroon',
                              cursor: 'pointer',
                              padding: '5px 10px'
                            }}
                          />
                        )}
                      </td>

                      <td style={{ width: '34%' }}>&nbsp;</td>

                      {/* Next / Got It Button */}
                      <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                        {currentPrcIndex < principleList.length - 1 ? (
                          <img
                            src={NextStepBtnSrc}
                            alt="Next"
                            onClick={() => {
                              const nextIndex = currentPrcIndex + 1;
                              setCurrentPrcIndex(nextIndex);
                              const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                              const countryParam = params.get('country') || 'Australia';
                              fetchPrincipleContent(principleList[nextIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                            }}
                            onMouseOver={handleNextStepBtnMouseOver}
                            onMouseOut={handleNextStepBtnMouseOut}
                            style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                          />
                        ) : (
                          <img
                            src={GotItBtnSrc}
                            id="imgGotIt"
                            alt="Got It"
                            onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                            onMouseOver={handleGotItBtnMouseOver}
                            onMouseOut={handleGotItBtnMouseOut}
                            style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}

          {showSolnModal && (
            <>
              <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => {
                setShowSolnModal(false);
              }}></div>
              <div id="divPCS" style={{ display: 'block' }}>
                <table id="tblTitlePCS" className="solution" cellSpacing="0" cellPadding="0" width="100%">
                  <tbody>
                    <tr>
                      <td id="tdPCSTitle1">Step by step solution</td>
                      <td id="tdPCSClose" align="right" valign="top">
                    <button
                      type="button"
                      aria-label="Close solution"
                      onClick={() => setShowSolnModal(false)}
                      style={{ width: '30px', height: '30px', margin: '5px 15px 5px 0', padding: 0, border: 0, borderRadius: 0, backgroundColor: '#ff6500', color: '#fff', fontSize: '18px', lineHeight: '30px', textAlign: 'center', cursor: 'pointer' }}
                    >
                      ×
                    </button>
                  </td>
                    </tr>
                  </tbody>
                </table>
                <div id="divFramePCS">
                  {isSolnLoading ? <Loading /> : (
                    <iframe
                      id="iFrameSolution"
                      ref={solnIframeRef}
                      title="Solution"
                      srcDoc={solnContent}
                      style={{ width: '100%', border: 'none', minHeight: '50px' }}
                      onLoad={() => {
                        const iframe = solnIframeRef.current;
                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) {
                          console.error("Iframe document or window not ready in onLoad.");
                          return;
                        }
                        try {
                          const iframeDoc = iframe.contentDocument;
                          const style = iframeDoc.createElement('style');
                          style.textContent = `
                                                tr[id^="trSolStepLHS"] td {
                                                    width: 50% !important;
                                                    box-sizing: border-box !important;
                                                }

                                                table[id^="tblSol"] tr td:first-child {
                                                    width: 50% !important;
                                                }

                                                table[id^="tblSol"] tr td:nth-child(2) {
                                                    width: 50% !important;
                                                }
                                            `;
                          if (iframeDoc.head) {
                            iframeDoc.head.appendChild(style);
                          }
                          const stepsInput = iframeDoc.getElementById('NoOfSteps') as HTMLInputElement;
                          const totalSteps = parseInt(stepsInput?.value || '0', 10);
                          setNoOfSteps(totalSteps);

                          const isAutoExpanded = iframeDoc.getElementById('IsAutoExpanded');

                          const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                          stepRows.forEach((step) => {
                            step.querySelectorAll<HTMLElement>(':scope > td').forEach((cell) => {
                              if (!cell.style.color && !cell.hasAttribute('color')) cell.style.color = 'black';
                            });
                          });
                          let firstStepHeight = 150;

                          stepRows.forEach((step, index) => {
                        const rhsCell = step.querySelector<HTMLElement>(':scope > td:last-of-type');
                        rhsCell?.style.setProperty('text-align', 'left', 'important');
                        rhsCell?.style.setProperty('padding-left', '12px', 'important');
                            if (index <= currentSolnNo || isAutoExpanded) {
                              step.style.display = 'table-row';
                            } else {
                              step.style.display = 'none';
                            }
                          });

                          if (totalSteps === 0) {
                            iframe.style.height = '50px';
                          }

                          setTimeout(() => {
                            if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                            const contentHeight = iframe.contentDocument.body.scrollHeight + 5;

                            const divPCS = document.getElementById('divPCS') as HTMLElement;
                            const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                            const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                            if (divPCS && titleTable && navTable) {
                              const maxModalHeight = window.innerHeight * 0.6;
                              const currentModalHeight = divPCS.offsetHeight;
                              const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;

                              if (contentHeight > maxIframeHeight) {
                                iframe.style.height = `${maxIframeHeight}px`;
                                iframe.style.overflowY = 'auto';
                              } else {
                                iframe.style.height = `${Math.max(contentHeight, 50)}px`;
                                iframe.style.overflowY = 'hidden';
                              }
                            }

                            if (isAutoExpanded) {
                              setCurrentSolnNo(totalSteps - 1);
                              if (solutionSeen !== 'Y') {
                                setSolutionSeen('Y');
                              }
                              iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);
                            } else {
                              if (stepRows.length > 0) {
                                firstStepHeight = stepRows[0].scrollHeight + 5;
                                iframe.style.height = `${Math.max(firstStepHeight, 150)}px`;
                                iframe.style.overflowY = 'hidden';
                              }
                            }
                          }, 50);

                          iframeDoc.querySelectorAll<HTMLImageElement>('img[id^="KsdImg"]').forEach(img => {
                        const index = img.id.substring(6);
                        const ksdDiv = iframeDoc.getElementById(`KsdDiv${index}`);
                        const content = ksdDiv?.getAttribute('data-ksd-content');
                        const wasPreviouslyRevealed = revealedSolnSteps.includes(Number(index));
                        const showCell = img.closest('td');
                        showCell?.style.setProperty('text-align', 'left', 'important');
                        showCell?.style.setProperty('padding-left', '12px', 'important');
                        const answerCell = ksdDiv?.closest('td') as HTMLTableCellElement | null;

                        const revealAnswer = () => {
                          if (!content || !showCell || !answerCell) return;
                          showCell.remove();
                          answerCell.colSpan = 2;
                          answerCell.innerHTML = content;
                          answerCell.style.setProperty('width', '50%', 'important');
                          answerCell.style.setProperty('max-width', 'none', 'important');
                          answerCell.style.setProperty('vertical-align', 'middle', 'important');
                          answerCell.style.setProperty('text-align', 'left', 'important');
                          answerCell.style.setProperty('padding-left', '12px', 'important');
                          answerCell.querySelectorAll<HTMLElement>('td').forEach(cell => {
                            cell.style.setProperty('text-align', 'left', 'important');
                            cell.style.setProperty('padding-left', '12px', 'important');
                          });
                        };

                        if (content && answerCell && wasPreviouslyRevealed) {
                          revealAnswer();
                          return;
                        }

                        img.onclick = () => {
                          if (img.getAttribute('alt') === '1') {
                            revealAnswer();
                            setRevealedSolnSteps(previous => previous.includes(Number(index)) ? previous : [...previous, Number(index)]);
                          }
                        };
                      });

                        } catch (e) {
                          console.error("Error inside solution iframe onLoad:", e);
                        }
                      }}
                    />
                  )}
                </div>
                <table id="tblNavPCS" className="solution" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
                  <tbody>
                    <tr>
                      <td align="left" style={{ width: '33%', paddingLeft: '15px' }}></td>
                      <td style={{ width: '34%' }}>&nbsp;</td>
                      <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                        {!isSolnLoading && noOfSteps > 0 && currentSolnNo < noOfSteps - 1 && (
                          <img
                            id="btnPCSNext"
                            src={NextStepBtnSrc}
                            alt="Next Step"
                            onClick={() => {
                              const nextStep = currentSolnNo + 1;
                              const iframe = solnIframeRef.current;

                              if (iframe?.contentDocument?.body) {
                                const iframeDoc = iframe.contentDocument;

                                const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                                if (nextStep >= stepRows.length) return;

                                const nextStepElement = stepRows[nextStep];
                                nextStepElement.style.display = 'table-row';

                                setTimeout(() => {
                                  if (!iframe.contentDocument) return;

                                  const currentIframeHeight = iframe.offsetHeight;
                                  const newStepHeight = nextStepElement.scrollHeight;

                                  const divPCS = document.getElementById('divPCS') as HTMLElement;
                                  const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                  const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                                  if (!divPCS || !titleTable || !navTable) return;

                                  const maxModalHeight = window.innerHeight * 0.6;
                                  const currentModalHeight = divPCS.offsetHeight;

                                  if (currentModalHeight >= maxModalHeight) {
                                    iframe.style.overflowY = 'auto';
                                  } else {
                                    const newIframeHeight = currentIframeHeight + newStepHeight;

                                    const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;

                                    if (newIframeHeight > maxIframeHeight) {
                                      iframe.style.height = `${maxIframeHeight}px`;
                                      iframe.style.overflowY = 'auto';
                                    } else {
                                      iframe.style.height = `${newIframeHeight}px`;
                                    }
                                  }

                                  iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);

                                });

                                setCurrentSolnNo(nextStep);
                                if (solutionSeen !== 'Y') {
                                  setSolutionSeen(nextStep + 1);
                                }
                              }
                            }}
                            onMouseOver={handleNextStepBtnMouseOver}
                            onMouseOut={handleNextStepBtnMouseOut}
                            style={{ cursor: 'pointer' }}
                          />
                        )}
                        {!isSolnLoading && (noOfSteps === 0 || currentSolnNo === noOfSteps - 1) && (
                          <img
                            id="btnPCSClose"
                            src={GotItBtnSrc}
                            alt="Got It"
                            onClick={() => {
                              setShowSolnModal(false);
                              setSolutionSeen('Y');
                            }}
                            onMouseOver={handleGotItBtnMouseOver}
                            onMouseOut={handleGotItBtnMouseOut}
                            style={{ cursor: 'pointer', display: isSolnLoading ? 'none' : 'inline-block' }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
        </>,
        document.body
      )}
    </>
  );
};

export default forwardRef(RadioQns);
